import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import censo from "../../Assets/Projects/censo.png";
import migracion from "../../Assets/Projects/1000465604.jpg";
import migracion_valpo from "../../Assets/Projects/1000466844.jpg";
import puerto_varas from "../../Assets/Projects/puerto_varas.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Mi <strong className="purple">Trabajo </strong>
        </h1>
        <p style={{ color: "white" }}>
          Aquí están algunos proyectos que he realizado recientemente.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={puerto_varas}
              isBlog={false}
              title="Crecimiento Urbano en Tiempos de Pandemia"
              description="Modelado de patrones urbanos con autómatas celulares en la ciudad de Puerto varas, Chile. StoryMap y poster científico presentando resultados preliminares en el XLV Congreso Nacional e XXX Congreso Internacional de Geografía, Villarrica 2025."
              ghLink=""
              demoLink="https://storymaps.arcgis.com/stories/19390fc04d684249a02775a1744a5d20"
              pdfLink="/Poster_v2.pdf"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={migracion}
              isBlog={false}
              title="Migración Interna en Chile"
              description="Este artículo analiza las principales tendencias de la migración interna en Chile, destacando las comunas que aumentaron o perdieron población según el censo de 2024."
              demoLink="https://www.latercera.com/que-pasa/noticia/a-donde-estan-escapando-los-chilenos-las-10-comunas-con-mayor-migracion-interna/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={migracion_valpo}
              isBlog={false}
              title="Patrones de Migración en Valparaíso"
              description="Centrado en la Región de Valparaíso, este artículo explora los cambios migratorios locales revelados por el censo de 2024 y analiza los factores que impulsan a las personas a desplazarse dentro de la región."
              demoLink="https://www.litoralpress.cl/SimbiuPDF/2025/06/24/5991128.pdf"
            />
            
          </Col>
                    <Col md={4} className="project-card">
            <ProjectCard
              imgPath={censo}
              isBlog={false}
              title="Crecimiento de Vivienda en el Sur de Chile"
              description="Hallazgos preliminares sobre la expansión habitacional entre los censos de 2017 y 2024 en la macrozona sur de Chile."
              ghLink="https://github.com/Jap-25/shinycenso"
              demoLink="https://jap-24.shinyapps.io/censo_viviendas/"
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
